export const ACTIVE_MENU_GROUP_LOCAL_STORAGE_KEY = 'activeSideMenuGroup';